import Layout from '../../components/Layout';
import Menu from '../../components/Layout/Menu';
import PagesContent from '../../components/Pages/Pages';

export default function Pages(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Pages page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <PagesContent />
    </Layout>
  );
}
